// 职位管理模块

//获取企业下的所有职位
function joblistInCompany(entid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { pagename: "bgetentjoblist", entid, action: "edit" },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("获取企业下的所有职位出错");
            resolve(false);
          }
        } else {
          console.log("获取企业下的所有职位出错");
          resolve(false);
        }
      }
    });
  });
}

//获取职位的投递人数
function jobsEnrolment(arrjobid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { type: "a", action: "edit", userid: Cookies.get("userid-b"), arrjobid, pagename: "bGetJobCount" },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("获取职位的投递人数出错");
            resolve(false);
          }
        } else {
          console.log("获取职位的投递人数出错");
          resolve(false);
        }
      }
    });
  });
}

//获取职位审核与面试信息
function jobsMeetEnrolment(mdate, countnum = 10, currpage = 1, QueryStr) {
  QueryStr = JSON.stringify(QueryStr);
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { type: "a", action: "edit", userid: Cookies.get("userid-b"), mdate, countnum, currpage, QueryStr, pagename: "bGetDateJobCount" },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("获取职位审核与面试信息出错");
            resolve(false);
          }
        } else {
          console.log("获取职位审核与面试信息出错");
          resolve(false);
        }
      }
    });
  });
}

//获取b角内部职位的投递情况
function jobProgressEnrolment(jobid = "", strstatus = "", currpage = 1, countnum = 10) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { type: "a", action: "edit", userid: Cookies.get("userid-b"), jobid, countnum, currpage, strstatus, pagename: "bGetBJobUserList" },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("获取b角内部职位的投递情况出错");
            resolve(false);
          }
        } else {
          console.log("获取b角内部职位的投递情况出错");
          resolve(false);
        }
      }
    });
  });
}

//职位下线
function offlineJob(jobid, entid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { type: "a", action: "save", jobid, entid, userid: Cookies.get("userid-b"), pagename: "bsetentjoboffline" },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            let jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(true) : resolve(false);
          } catch (e) {
            console.log("职位下线出错");
            resolve(false);
          }
        } else {
          console.log("职位下线出错");
          resolve(false);
        }
      }
    });
  });
}

//获取职位地点
function jobLocation(jobId, entid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "edit", entid, userid: Cookies.get("userid-b"), jobId, pagename: "entjobaddrinfo" },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const res = JSON.parse(res);
            res ? resolve(res) : resolve(false);
          } catch (e) {
            console.log("获取职位地点出错");
            resolve(false);
          }
        } else {
          console.log("获取职位地点出错");
          resolve(false);
        }
      }
    });
  });
}

//获取职位信息
function getJobInfor(jobId) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "edit", pagename: "bGetJobInfo", pageid: "1", jobId },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("获取职位信息出错");
            resolve(false);
          }
        } else {
          console.log("获取职位信息出错");
          resolve(false);
        }
      }
    });
  });
}

//获取职位信息(根据pubid)
function pubidGetJobInfo(pubid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "edit", userid: Cookies.get("userid-b"), pubid, pagename: "bGetEntJobListByPubid" },
      dataType: "json",
      success: res => {
        if (res) {
          let str = JSON.parse(res);
          resolve(str.status == "ok" ? str.msg : false);
        } else {
          resolve(false);
        }
      }
    });
  });
}

//新增修改职位
function manipulateJob(entid, jobid, entJobInfo) {
  return new Promise(resolve => {
    $.ajax({
      url: APIB,
      async: true,
      type: "post",
      dataType: "json",
      data: { action: "save", userid: Cookies.get("userid-b"), entid, jobid, pagename: "bentjobinfo", entJobInfo: JSON.stringify(entJobInfo) },
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(true) : resolve(false);
          } catch (e) {
            console.log("新增修改职位出错");
            resolve(false);
          }
        } else {
          console.log("新增修改职位出错");
          resolve(false);
        }
      }
    });
  });
}

//获取职位的审核历史
function jobIdentifyHistory(jobid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "edit", pagename: 'bgetjoblistinfo', userid: Cookies.get("userid-b"), jobid },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            resolve(false);
          }
        } else {
          resolve(false);
        }
      }
    });
  });
}

//获取职位的门店
function getJobsStore(entid, jobid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "edit", pagename: 'entjobaddrinfo', userid: Cookies.get("userid-b"), entid, jobid },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            resolve(jsonRes);
          } catch (e) {
            resolve(false);
          }
        } else {
          resolve(false);
        }
      }
    });
  });
}

//获取投递人
function deliveryList(jobid, currpage = 1, countNum = 10) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "edit", userid: Cookies.get("userid-b"), pagename: "bGetJobUserList", jobid, currpage, countNum },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const josnRes = JSON.parse(res);
            josnRes.status == "ok" ? resolve(josnRes) : resolve(false);
          } catch (e) {
            console.log("获取投递人出错");
            resolve(false);
          }
        } else {
          console.log("获取投递人出错");
          resolve(false);
        }
      }
    });
  });
}

export default {
  joblistInCompany,
  jobsEnrolment,
  jobsMeetEnrolment,
  jobProgressEnrolment,
  offlineJob,
  jobLocation,
  getJobInfor,
  pubidGetJobInfo,
  manipulateJob,
  jobIdentifyHistory,
  getJobsStore,
  deliveryList
};
